/**
 * @fileoverview QuarterDropdown Component - Quarter selection dropdown
 * 
 * Provides a dropdown selector for quarterly data filtering:
 * - Dynamic quarter options from data
 * - "All" option for showing all quarters
 * - Controlled component pattern
 * - Callback for selection changes
 * - Consistent styling and behavior
 * 
 * @component
 * @example
 * <QuarterDropdown 
 *   quarters={['Q1 2024', 'Q2 2024']} 
 *   selectedQuarter="Q1 2024"
 *   onQuarterChange={handleQuarterChange}
 * />
 * 
 * @requires React
 * 
 * @author By John Bellew - Infinia.ie - last updated 10/07/2025
 */

import React from 'react';

/**
 * QuarterDropdown Component
 * 
 * Renders a dropdown selector for quarter-based filtering.
 * 
 * @component
 * @param {Object} props - Component properties
 * @param {Array<string>} props.quarters - Array of available quarters
 * @param {string} props.selectedQuarter - Currently selected quarter
 * @param {Function} props.onQuarterChange - Callback when quarter selection changes
 * 
 * @returns {JSX.Element} Quarter selection dropdown
 */
const QuarterDropdown = ({ quarters, selectedQuarter, onQuarterChange }) => {
    return (
        <select
            id="quarter-select"
            value={selectedQuarter}
            onChange={(e) => onQuarterChange(e.target.value)}
        >
            <option value="">Quarter (ALL)</option>  {/* Empty string as value for All Quarters */}
            {quarters.map((quarter, index) => (
                <option key={index} value={quarter}>
                    {quarter}
                </option>
            ))}
        </select>
    );
};


export default QuarterDropdown;